import { render, staticRenderFns } from "./PublicChamberMaterials.vue?vue&type=template&id=202f36ce&scoped=true&"
import script from "./PublicChamberMaterials.vue?vue&type=script&lang=js&"
export * from "./PublicChamberMaterials.vue?vue&type=script&lang=js&"
import style0 from "./PublicChamberMaterials.vue?vue&type=style&index=0&id=202f36ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202f36ce",
  null
  
)

export default component.exports